class JudgeProfileController {
	constructor(JudgesFactory, AuthFactory, PlayersFactory, $rootScope, $stateParams, $filter, $state, ngDialog, URLS){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');

		vm.rootScope = $rootScope;

		vm.$onInit = () =>{
			vm.options = [
				{id: 1, name: 'INFORMATION'},
				{id: 2, name: 'MATCHES'},
			];
			vm.activeOption = 1;
			vm.judgeId = $stateParams.id;
			vm.judge = {};
			if(vm.judgeId){
				JudgesFactory.getOne(vm.judgeId).then(response =>{
					vm.judge = response.data;
					vm.gridOptions.data = vm.judge.matches;
				});
			}
		};

		vm.gridOptions = {
			enableSorting: true,
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'matchSortName',
					name: $translate('NAME'),
					enableFiltering: true,
				},{
					field: 'matchDate',
					name: $translate('DATE'),
					enableFiltering: true,
					width: '200',
				}
			],
		};

		vm.hasPermission = (permission) =>{
			return vm.rootScope.user.canDo(permission);
		};

		vm.goToMatchProfile = (matchId) =>{
			$state.go('match-profile', {id: matchId});
		};

		vm.getJudgeImage = function () {
			if(vm.judge.img){
				return URLS.IMAGES_URL + "/judges/" + vm.judge.img;
			}else{
				return 'assets/images/no_avatar.png';
			}
		};

		vm.getJudgeCard = () =>{
			const tabWindowId = window.open('about:blank', '_blank');
			JudgesFactory.card(vm.judgeId).then(response =>{
				let file = new Blob([response.data], {type: 'application/pdf'});
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	}
}

export default JudgeProfileController;



// WEBPACK FOOTER //
// ./client/app/components/judges/judgeProfile/judgeProfile.controller.js